/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S1_Li3Inputs */

const en_guide_json_vs_yaml_xml_s1_li3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>XML</strong>: Feature-rich (attributes, namespaces, schemas), dominant in enterprise systems and SOAP APIs`)
};

const ko_guide_json_vs_yaml_xml_s1_li3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>XML</strong>: 풍부한 기능(속성, 네임스페이스, 스키마), 엔터프라이즈 시스템과 SOAP API에서 지배적`)
};

const ja_guide_json_vs_yaml_xml_s1_li3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>XML</strong>: 機能豊富（属性、名前空間、スキーマ）、エンタープライズシステムやSOAP APIで主流`)
};

/**
* | output |
* | --- |
* | "<strong>XML</strong>: Feature-rich (attributes, namespaces, schemas), dominant in enterprise systems and SOAP APIs" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S1_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s1_li3 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S1_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S1_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s1_li3(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s1_li3(inputs)
	return ja_guide_json_vs_yaml_xml_s1_li3(inputs)
});